import { t } from '@lingui/macro';

export const sitePMZoneLabelsFn = (): Record<string, string> => ({
  address: t({ message: 'Address', id: '[SiteDetailsLabel.Address]' }),
  loggerType: t({ message: 'Logger', id: '[SiteDetailsLabel.Logger]' }),
  serialNumber: t({ message: 'Serial number', id: '[SiteDetailsLabel.SerialNumber]' }),
  smsNumber: t({ message: 'SMS', id: '[SiteDetailsLabel.SMS]' }),
  batteryLevel: t({ message: 'Battery level', id: '[SiteDetailsLabel.BatteryLevel]' }),
  lastCallIn: t({
    message: 'Last call in',
    id: '[SiteDetailsLabel.LastCallIn]',
  }),
  lastCommand: t({
    message: 'Last command',
    id: '[SiteDetailsLabel.LastCommand]',
  }),
  lastCallInType: t({
    message: 'Last call in type',
    id: '[SiteDetailsLabel.LastCallInType]',
  }),
  signalLevel: t({ message: 'Signal level', id: '[SiteDetailsLabel.SignalLevel]' }),
});
